/** Learn split-view hub — Language vs Role navigation mode (local persistence). */

export const ROADMAP_LEARN_HUB_MODE_STORAGE_KEY = 'flashcode_roadmap_learn_hub_mode';

export const ROADMAP_LEARN_MODES = {
  language: 'language',
  role: 'role'
};

/** @returns {'language' | 'role'} */
export function readRoadmapLearnHubMode() {
  if (typeof window === 'undefined') return ROADMAP_LEARN_MODES.language;
  try {
    const raw = window.localStorage.getItem(ROADMAP_LEARN_HUB_MODE_STORAGE_KEY);
    return raw === ROADMAP_LEARN_MODES.role
      ? ROADMAP_LEARN_MODES.role
      : ROADMAP_LEARN_MODES.language;
  } catch {
    return ROADMAP_LEARN_MODES.language;
  }
}

/** @param {'language' | 'role'} mode */
export function writeRoadmapLearnHubMode(mode) {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(
      ROADMAP_LEARN_HUB_MODE_STORAGE_KEY,
      mode === ROADMAP_LEARN_MODES.role ? ROADMAP_LEARN_MODES.role : ROADMAP_LEARN_MODES.language
    );
  } catch {
    /* ignore quota / privacy mode */
  }
}
